import { HOME_ROUTE } from '../navigation/routes'

const navigation = [
  {
    to: HOME_ROUTE,
    label: 'Inicio',
    url: true,
  },
  {
    to: 'vinos',
    label: 'Nuestros Vinos',
    url: true,
  },
  {
    to: 'contact',
    label: 'Contacto',
  },
]

export default navigation
